import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delayvyed5wvki0ic as delay } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionConnectionException12fjxvnnqzby5 as SubscriptionConnectionException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from '../../../../../../../kotlinx-atomicfu/kotlinx/atomicfu/locks/Synchronized.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ConnectionKeepAliveServerMessage_instance2ucdc3b7nis36 as ConnectionKeepAliveServerMessage_instance,
  PongServerMessage_instancegdhl9dh77vj7 as PongServerMessage_instance,
  PingServerMessage_instance2x2b9b7bh91v2 as PingServerMessage_instance,
  ParseErrorServerMessage28gxznaow3b26 as ParseErrorServerMessage,
  OperationErrorServerMessage3f3enfqsilvrv as OperationErrorServerMessage,
  CompleteServerMessage1c62v9ocjho2f as CompleteServerMessage,
  ResponseServerMessage1aifb0dqdz3sq as ResponseServerMessage,
  ConnectionErrorServerMessage21355wd69v8tf as ConnectionErrorServerMessage,
  ConnectionAckServerMessage_instance2uyrftb08sig4 as ConnectionAckServerMessage_instance,
} from '../ServerMessage.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  DataClientMessage3splhk6u8gldd as DataClientMessage,
  TextClientMessage15942w7lyj1yt as TextClientMessage,
} from '../ClientMessage.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function restartIdleTimeout($this) {
  var tmp0_safe_receiver = $this.u67_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.mx();
  }
  var tmp = $this;
  tmp.u67_1 = launch($this.t67_1, VOID, VOID, SubscribableWebSocket$restartIdleTimeout$slambda($this));
}
function shutdownInternal($this, cause) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var listeners = ArrayList().p2();
  // Inline function 'kotlinx.atomicfu.locks.withLock' call
  $this.s67_1;
  if ($this.w67_1.equals(SocketState_ShutDown_getInstance())) {
    return Unit_instance;
  }
  $this.w67_1 = SocketState_ShutDown_getInstance();
  cancel($this.t67_1);
  $this.x67_1 = cause;
  listeners.u2($this.y67_1.w4());
  $this.y67_1.a5();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = listeners.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    element.k68(cause);
  }
}
function SubscribableWebSocket$restartIdleTimeout$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.r67_1, $completion);
    this$0.p68(ApolloNetworkException().d47('WebSocket is idle'), 1001, 'Idle');
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onOpen$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.a68_1, yield* this$0.o67_1.k66($completion));
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onOpen$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(this$0.q67_1, $completion);
    this$0.p68(ApolloNetworkException().d47('Timeout while waiting for connection_ack'), 1001, 'Timeout while waiting for connection_ack');
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onMessage$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    while (true) {
      yield* delay(this$0.p67_1, $completion);
      var tmp0_safe_receiver = this$0.o67_1.n66();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        send(this$0.a68_1, tmp0_safe_receiver);
      }
    }
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$onMessage$slambda_0(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this$0.z67_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      send(this$0.a68_1, yield* this$0.o67_1.l66(element, $completion));
    }
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$startOperation$slambda(this$0, $request) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.a68_1, yield* this$0.o67_1.l66($request, $completion));
    return Unit_instance;
  }, 1);
}
function SubscribableWebSocket$stopOperation$slambda(this$0, $request) {
  return constructCallableReference(function *($this$launch, $completion) {
    send(this$0.a68_1, this$0.o67_1.m66($request));
    return Unit_instance;
  }, 1);
}
var SubscribableWebSocketClass;
function SubscribableWebSocket() {
  if (SubscribableWebSocketClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, httpHeaders, wsProtocol, pingInterval, connectionAcknowledgeTimeout, idleTimeout) {
        this.o67_1 = wsProtocol;
        this.p67_1 = pingInterval;
        this.q67_1 = connectionAcknowledgeTimeout;
        this.r67_1 = idleTimeout;
        var tmp = this;
        // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
        tmp.s67_1 = get_atomicfu$reentrantLock();
        this.t67_1 = CoroutineScope(Dispatchers_getInstance().g13_1);
        this.u67_1 = null;
        this.v67_1 = null;
        this.w67_1 = SocketState_AwaitOpen_getInstance();
        this.x67_1 = null;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.y67_1 = LinkedHashMap().ec();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_1.z67_1 = ArrayList().p2();
        var tmp_2;
        var tmp$ret$3;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_3;
          if (isInterface(httpHeaders, Collection())) {
            tmp_3 = httpHeaders.n1();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$3 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = httpHeaders.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            if (element.w48_1.toLowerCase() === 'sec-websocket-protocol') {
              tmp$ret$3 = true;
              break $l$block_0;
            }
          }
          tmp$ret$3 = false;
        }
        if (tmp$ret$3) {
          tmp_2 = httpHeaders;
        } else {
          tmp_2 = plus(httpHeaders, new (HttpHeader())('Sec-WebSocket-Protocol', this.o67_1.h1()));
        }
        var headers = tmp_2;
        this.a68_1 = webSocketEngine.q68(serverUrl, headers, this);
      }
      r68(markActive) {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.s67_1;
        // Inline function 'kotlin.also' call
        var this_0 = this.w67_1.equals(SocketState_ShutDown_getInstance());
        if (!this_0 && markActive) {
          var tmp0_safe_receiver = this.u67_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.mx();
          }
          this.u67_1 = null;
        }
        return this_0;
      }
      p68(cause, code, reason) {
        shutdownInternal(this, cause);
        this.a68_1.s68(code, reason);
      }
      t68() {
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.s67_1;
        if (this.w67_1.w1_1 === 0) {
          launch(this.t67_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda(this));
          var tmp = this;
          tmp.v67_1 = launch(this.t67_1, VOID, VOID, SubscribableWebSocket$onOpen$slambda_0(this));
          this.w67_1 = SocketState_AwaitAck_getInstance();
        }
      }
      u68(text) {
        var message = this.o67_1.p66(text);
        if (equals(message, ConnectionAckServerMessage_instance)) {
          var tmp0_safe_receiver = this.v67_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.mx();
          }
          this.v67_1 = null;
          // Inline function 'kotlinx.atomicfu.locks.withLock' call
          this.s67_1;
          if (!this.w67_1.equals(SocketState_AwaitAck_getInstance())) {
            return Unit_instance;
          }
          this.w67_1 = SocketState_Connected_getInstance();
          var tmp = this.p67_1;
          if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
            launch(this.t67_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda(this));
          }
          launch(this.t67_1, VOID, VOID, SubscribableWebSocket$onMessage$slambda_0(this));
        } else {
          if (message instanceof ConnectionErrorServerMessage()) {
            this.p68(SubscriptionConnectionException().u4e(message.v68_1), 1001, 'Connection error');
          } else {
            if (message instanceof ResponseServerMessage()) {
              // Inline function 'kotlinx.atomicfu.locks.withLock' call
              this.s67_1;
              var tmp1_safe_receiver = this.y67_1.u4(message.q66_1);
              if (tmp1_safe_receiver == null)
                null;
              else {
                tmp1_safe_receiver.g68(message.r66_1);
              }
            } else {
              if (message instanceof CompleteServerMessage()) {
                // Inline function 'kotlinx.atomicfu.locks.withLock' call
                this.s67_1;
                var tmp2_safe_receiver = this.y67_1.u4(message.s66_1);
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  tmp2_safe_receiver.i68();
                }
              } else {
                if (message instanceof OperationErrorServerMessage()) {
                  // Inline function 'kotlinx.atomicfu.locks.withLock' call
                  this.s67_1;
                  var tmp3_safe_receiver = this.y67_1.u4(message.t66_1);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    tmp3_safe_receiver.j68(message.u66_1);
                  }
                } else {
                  if (message instanceof ParseErrorServerMessage()) {
                    println("Cannot parse message: '" + message.v66_1 + "'");
                  } else {
                    if (equals(message, PingServerMessage_instance)) {
                      var tmp4_safe_receiver = this.o67_1.o66();
                      if (tmp4_safe_receiver == null)
                        null;
                      else {
                        // Inline function 'kotlin.let' call
                        send(this.a68_1, tmp4_safe_receiver);
                      }
                    } else {
                      if (!equals(message, PongServerMessage_instance)) {
                        if (!equals(message, ConnectionKeepAliveServerMessage_instance)) {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      w68(data) {
        this.u68(decodeToString(data));
      }
      x68(cause) {
        shutdownInternal(this, cause);
      }
      y68(code, reason) {
        shutdownInternal(this, ApolloWebSocketClosedException().u4d(code == null ? 1001 : code, reason));
      }
      b68(request, listener) {
        var cause = null;
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.s67_1;
        var tmp0_safe_receiver = this.u67_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.mx();
        }
        this.u67_1 = null;
        var tmp;
        switch (this.w67_1.w1_1) {
          case 0:
          case 1:
            this.y67_1.x4(request.t40_1.toString(), listener);
            tmp = this.z67_1.i2(request);
            break;
          case 2:
            this.y67_1.x4(request.t40_1.toString(), listener);
            tmp = launch(this.t67_1, VOID, VOID, SubscribableWebSocket$startOperation$slambda(this, request));
            break;
          case 3:
            cause = DefaultApolloException().p42('Apollo: the WebSocket is shut down', this.x67_1);
            tmp = Unit_instance;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        if (!(cause == null)) {
          listener.k68(ensureNotNull(cause));
        }
      }
      c68(request) {
        var id = request.t40_1.toString();
        // Inline function 'kotlinx.atomicfu.locks.withLock' call
        this.s67_1;
        if (this.y67_1.s4(id)) {
          this.y67_1.y4(id);
          launch(this.t67_1, VOID, VOID, SubscribableWebSocket$stopOperation$slambda(this, request));
          if (this.y67_1.n1()) {
            restartIdleTimeout(this);
          }
        }
      }
    }
    initMetadataForClass($, 'SubscribableWebSocket');
    SubscribableWebSocketClass = $;
  }
  return SubscribableWebSocketClass;
}
var SocketState_AwaitOpen_instance;
var SocketState_AwaitAck_instance;
var SocketState_Connected_instance;
var SocketState_ShutDown_instance;
var SocketState_entriesInitialized;
function SocketState_initEntries() {
  if (SocketState_entriesInitialized)
    return Unit_instance;
  SocketState_entriesInitialized = true;
  SocketState_AwaitOpen_instance = new (SocketState())('AwaitOpen', 0);
  SocketState_AwaitAck_instance = new (SocketState())('AwaitAck', 1);
  SocketState_Connected_instance = new (SocketState())('Connected', 2);
  SocketState_ShutDown_instance = new (SocketState())('ShutDown', 3);
}
var SocketStateClass;
function SocketState() {
  if (SocketStateClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SocketState');
    SocketStateClass = $;
  }
  return SocketStateClass;
}
function send(_this__u8e3s4, clientMessage) {
  if (clientMessage instanceof TextClientMessage()) {
    _this__u8e3s4.b69(clientMessage.h66_1);
  } else {
    if (clientMessage instanceof DataClientMessage()) {
      _this__u8e3s4.a69(clientMessage.z68_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function SocketState_AwaitOpen_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitOpen_instance;
}
function SocketState_AwaitAck_getInstance() {
  SocketState_initEntries();
  return SocketState_AwaitAck_instance;
}
function SocketState_Connected_getInstance() {
  SocketState_initEntries();
  return SocketState_Connected_instance;
}
function SocketState_ShutDown_getInstance() {
  SocketState_initEntries();
  return SocketState_ShutDown_instance;
}
//region block: exports
export {
  SubscribableWebSocket as SubscribableWebSockethkxzhdarcovi,
};
//endregion

//# sourceMappingURL=SubscribableWebSocket.mjs.map
